import React from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropertyDetail from "../components/properties/PropertyDetail";
import DefaultLayout from "../components/layout/DefaultLayout";
import LoadingMessage from "../components/LoadingMessage";
import { startGetPropertyDetail } from "../actions/properties";
import ErrorMessage from "../components/ErrorMessage";

function PropertyDetailPage(props) {
  const { code } = useParams();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.property.property.loading);
  const loadedProperty = useSelector((state) => state.property.property.data);

  useEffect(() => {
    dispatch(startGetPropertyDetail(code));
  }, [code]);

  if (isLoading) {
    return <LoadingMessage></LoadingMessage>;
  } else if (
    loadedProperty !== undefined &&
    loadedProperty != null &&
    !isEmpty(loadedProperty)
  ) {
    const body = () => {
      return <PropertyDetail property={loadedProperty} />;
    };
    return (
      <div>
        <div>
          <DefaultLayout body={body()} />
        </div>
      </div>
    );
  } else {
    return <ErrorMessage message="No encontramos la propiedad"></ErrorMessage>;
  }
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export default PropertyDetailPage;
